const directions = {
    top: { x: 0, y: -1 },
    right: { x: 1, y: 0 },
    bottom: { x: 0, y: 1 },
    left: { x: -1, y: 0 },
};

export function getEditableRoutePoints({ sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition }, point) {
    const sourceDirection = directions[sourcePosition] || directions.bottom;
    const targetDirection = directions[targetPosition] || directions.top;
    const sourceLead = { x: sourceX + sourceDirection.x * 16, y: sourceY + sourceDirection.y * 16 };
    const targetLead = { x: targetX + targetDirection.x * 16, y: targetY + targetDirection.y * 16 };

    return [
        { x: sourceX, y: sourceY },
        sourceLead,
        { x: point.x, y: sourceLead.y },
        point,
        { x: targetLead.x, y: point.y },
        targetLead,
        { x: targetX, y: targetY },
    ];
}

export function routePointsToPath(points) {
    return points.map((point, index) => `${index ? 'L' : 'M'} ${point.x} ${point.y}`).join(' ');
}
